import React, { useState, useEffect, useContext } from 'react';
import { NavLink, withRouter, useLocation } from "react-router-dom";
import { IconMiniChatHeader, IconNotification } from "..";
import { Sidebar } from "./Sidebar";
import { GetTotalUnread } from '@fci/business-layer/services';
import AppContext from "./../../AppContext";
import networkHelpers from '@fci/business-layer/helpers/network-helpers';
import ChatContext from "../../Pages/Chat/ChatContext";
import { UserContext } from '../../UserContext';

const Header = (props) => {
    const location = useLocation();
    const [unreadNotification, setUnreadNotification] = useState(0);
    const [image, setImage] = useState('/assets/images/no-pict.png');
    const { InnerChatContext } = ChatContext;
    const { MenuContext } = AppContext;
    const chatContext = useContext(InnerChatContext);
    const { user } = useContext(UserContext);

    const menuProps = useContext(MenuContext);

    useEffect(() => {
        if (user?.userPicture?.derivative?.url) {
            setImage(user.userPicture.derivative.url);
        }
    }, [user]);

    useEffect(() => {
        if (location.pathname === '/login') return;

        const fetchUnread = async () => {
            if (document.visibilityState === 'visible' && networkHelpers.isOnline()) {
                try {
                    const n = await GetTotalUnread();
                    if (n?.data?.success) {
                        setUnreadNotification(parseInt(n.data.total));
                    }
                } catch (e) {
                    console.log(e?.response?.data?.message ?? e);
                }
            }
        };

        fetchUnread();

        const interval = setInterval(fetchUnread, 30000);

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                fetchUnread();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            clearInterval(interval);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [location.pathname]);

    if (location.pathname === '/login') {
        return null;
    }

    return (
        <>
            <header id="header" className="flex flex-none items-center justify-between pr-20 pl-20 h-64 bg-white">
                <NavLink to="/">
                    <img src={require('@fci/business-layer/assets/fci-logo.svg')}
                        alt="FCI"
                        style={{ width: 88 }} />
                </NavLink>

                <div className="flex items-center justify-between">
                    {!!chatContext &&
                        <div className="text-blue text-2xl mr-30 badge-wrapper">
                            <NavLink to={'/chat'}>
                                <IconMiniChatHeader />
                                {!!chatContext.state.totalUnreadMessages
                                    ? <div
                                        className="bg-violet badge badge-md header">!</div>
                                    : ''
                                }
                            </NavLink>
                        </div>
                    }

                    <div className="text-blue text-2xl mr-30 badge-wrapper">
                        <NavLink to={'/notifications'}>
                            <IconNotification />
                            {!!unreadNotification
                                ? <div className="bg-violet badge badge-md header">!</div>
                                : ''
                            }
                        </NavLink>
                    </div>

                    <div className={`hamburger${menuProps.showMenu ? ' open' : ''}`} onClick={menuProps.showMenu ? menuProps.closeMenu : menuProps.openMenu}>
                        <span />
                        <span />
                        <span />
                    </div>
                </div>
            </header>

            <React.Suspense fallback={<div />}>
                <Sidebar toggleMenu={menuProps.closeMenu} image={image} />
            </React.Suspense>
        </>
    );
};


export default withRouter(Header);
